{
  "name": "auditoria-medica-app",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@abacritt/angularx-social-login": "^2.3.0",
    "@angular/animations": "^21.1.4",
    "@angular/cdk": "^21.1.4",
    "@angular/common": "^21.1.4",
    "@angular/compiler": "^21.1.4",
    "@angular/core": "^21.1.4",
    "@angular/forms": "^21.1.4",
    "@angular/material": "^21.1.4",
    "@angular/material-moment-adapter": "^21.1.4",
    "@angular/platform-browser": "^21.1.4",
    "@angular/platform-browser-dynamic": "^21.1.4",
    "@angular/router": "^21.1.4",
    "@angular/service-worker": "^21.1.4",
    "@microsoft/signalr": "^9.0.6",
    "angularx-qrcode": "^21.0.4",
    "apexcharts": "^5.6.0",
    "crypto-js": "^4.2.0",
    "device-uuid": "^1.0.4",
    "dexie": "^4.2.1",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "jwt-decode": "^4.0.0",
    "moment": "^2.30.1",
    "ng-apexcharts": "^2.2.0",
    "ngx-mask": "^21.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "overrides": {
    "minimatch": "^10.2.1",
    "ajv": "^8.17.1",
    "rimraf": "^5.0.10",
    "glob": "^11.0.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.4",
    "@types/crypto-js": "^4.2.2",
    "@types/device-uuid": "^1.0.3",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.4.21",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.0.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.6",
    "tailwindcss": "^3.4.18",
    "typescript": "^5.9.3"
  }
}
